module.exports = __webpack_public_path__ + "static/media/twelve.5a2e7f57.jpg";